// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Salsa&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 900px) {
  html {
    font-size: 67.5% !important;
  }
}
.MuiTypography-h4 {
  font-weight: 600 !important;
  font-size: 2rem !important;
  line-height: 2rem !important;
  color: #001e50;
}

.MuiTypography-h3 {
  font-style: normal;
  font-weight: 500 !important;
  font-size: 1rem !important;
  line-height: 24px !important;
  color: #000000;
}

body {
  font-family: "Poppins" !important;
  background-color: #f8f8f8 !important;
}

.error {
  color: red;
  font-size: 12px;
  padding-left: 5px;
  margin-top: 2px;
}

.mainCardWrapper {
  border: 1px solid #e0e4e9;
  border-radius: 8px;
  padding: 30px;
  background-color: #fff;
}

.bxLabel {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #000;
  margin-top: 15px;
  margin-bottom: 15px;
}

.headerBx {
  display: flex;
  justify-content: space-between;
  border-radius: 8px;
  background-color: #fff;
  margin-bottom: 1rem;
  padding: 10px 0px;
  align-items: center;
}
.headerBx p {
  font-size: 24px;
  font-weight: 500;
  line-height: 36px;
}

.customBtn button {
  border-radius: 8px;
  height: 54px;
  color: #fff !important;
  font-family: Poppins;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}

.searchBx {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}
.searchBx .MuiInputBase-root {
  height: 58px;
  border-radius: 8px;
  background-color: #fff;
  width: 100%;
}
.searchBx .MuiIconButton-edgeEnd {
  padding-right: 0 !important;
}
.searchBx .MuiButton-containedPrimary {
  border-radius: 5px;
  height: 40px !important;
  font-size: 18px;
  padding: 10px 10px;
  font-weight: 600;
  line-height: 24px;
  text-transform: capitalize;
  box-shadow: none;
  background-color: #2a97ca;
  color: #fff;
}
.searchBx .MuiButton-containedPrimary span {
  font-family: Poppins;
  font-size: 15px;
}

.customTab .MuiButtonBase-root {
  border: 1px solid #e0e4e9;
}
.customTab .Mui-selected {
  color: #2a97ca !important;
}
.customTab button {
  height: 45px;
  font-weight: 600;
  font-size: 16px;
  padding-left: 45px;
  padding-right: 45px;
  text-transform: capitalize;
}
.customTab button:first-child {
  border-radius: 8px 0 0 0;
}
.customTab button:last-child {
  border-radius: 0 8px 0 0;
}
.customTab .MuiTabs-flexContainer {
  border-radius: 15px 15px 0 0;
}

.actionIcon {
  display: flex;
}

.form-card {
  border-radius: 8px;
  border: 1px solid #e0e4e9 !important;
  box-shadow: none !important;
  background: #fff;
  margin-bottom: 3%;
}

.cardHeading {
  font-size: 16px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  line-height: normal !important;
  margin-bottom: 12px !important;
}

.footer {
  position: fixed;
  bottom: 0px;
  background: rgb(255, 255, 255);
  text-align: center;
  width: 100%;
  font-size: 16px;
  font-weight: 500;
  z-index: 99999;
}

.activeBadge {
  background-color: #c5eed8 !important;
  color: #000 !important;
  border-radius: 50px !important;
  padding: 4px 28px !important;
  font-size: 13px !important;
  font-weight: 300 !important;
}

.inActiveBadge {
  background-color: #eaeaea !important;
  color: #000 !important;
  border-radius: 50px !important;
  padding: 4px 28px !important;
  font-size: 13px !important;
  font-weight: 300 !important;
}

.modalHeading {
  text-align: center;
}

.headPages p {
  font-size: 24px;
  font-weight: 500;
  line-height: 36px;
}

body {
  font-family: "Poppins" !important;
  background-color: #f8f8f8 !important;
}

.error {
  color: red;
  font-size: 12px;
  padding-left: 5px;
  margin-top: 2px;
}

.mainCardWrapper {
  border: 1px solid #e0e4e9;
  border-radius: 8px;
  padding: 30px;
  background-color: #fff;
}

.bxLabel {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #000;
  margin-top: 15px;
  margin-bottom: 15px;
}

.headerBx {
  display: flex;
  justify-content: space-between;
  border-radius: 8px;
  background-color: #fff;
  margin-bottom: 1rem;
  padding: 10px 0px;
  align-items: center;
}
.headerBx p {
  font-size: 24px;
  font-weight: 500;
  line-height: 36px;
}

.customBtn button {
  border-radius: 8px;
  height: 54px;
  color: #fff !important;
  font-family: Poppins;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}

.searchBx {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}
.searchBx .MuiInputBase-root {
  height: 58px;
  border-radius: 8px;
  background-color: #fff;
  width: 100%;
}
.searchBx .MuiIconButton-edgeEnd {
  padding-right: 0 !important;
}
.searchBx .MuiButton-containedPrimary {
  border-radius: 5px;
  height: 40px !important;
  font-size: 18px;
  padding: 10px 10px;
  font-weight: 600;
  line-height: 24px;
  text-transform: capitalize;
  box-shadow: none;
  background-color: #2a97ca;
  color: #fff;
}
.searchBx .MuiButton-containedPrimary span {
  font-family: Poppins;
  font-size: 15px;
}

.customTab .MuiButtonBase-root {
  border: 1px solid #e0e4e9;
}
.customTab .Mui-selected {
  color: #2a97ca !important;
}
.customTab button {
  height: 45px;
  font-weight: 600;
  font-size: 16px;
  padding-left: 45px;
  padding-right: 45px;
  text-transform: capitalize;
}
.customTab button:first-child {
  border-radius: 8px 0 0 0;
}
.customTab button:last-child {
  border-radius: 0 8px 0 0;
}
.customTab .MuiTabs-flexContainer {
  border-radius: 15px 15px 0 0;
}

.actionIcon {
  display: flex;
}

.form-card {
  border-radius: 8px;
  border: 1px solid #e0e4e9 !important;
  box-shadow: none !important;
  background: #fff;
  margin-bottom: 3%;
}

.cardHeading {
  font-size: 16px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  line-height: normal !important;
  margin-bottom: 12px !important;
}

.footer {
  position: fixed;
  bottom: 0px;
  background: rgb(255, 255, 255);
  text-align: center;
  width: 100%;
  font-size: 16px;
  font-weight: 500;
  z-index: 99999;
}

.activeBadge {
  background-color: #c5eed8 !important;
  color: #000 !important;
  border-radius: 50px !important;
  padding: 4px 28px !important;
  font-size: 13px !important;
  font-weight: 300 !important;
}

.inActiveBadge {
  background-color: #eaeaea !important;
  color: #000 !important;
  border-radius: 50px !important;
  padding: 4px 28px !important;
  font-size: 13px !important;
  font-weight: 300 !important;
}

.modalHeading {
  text-align: center;
}

.headPages p {
  font-size: 24px;
  font-weight: 500;
  line-height: 36px;
}

.tableWrapper {
  padding: 24px;
  border: 1px solid #e0e4e9;
  padding: 30px 20px;
  border-radius: 0px 0px 8px 8px;
  background-color: #fff;
}
.tableWrapper .MuiTableHead-root {
  background-color: #f3f3f3;
  white-space: noWrap;
}
.tableWrapper .MuiTableCell-head {
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0em;
  color: #020202;
  border-right: 1px solid #fff;
}
.tableWrapper .MuiTableCell-body {
  border-right: 1px solid #e7e7e7;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: #000000;
  padding: 8px;
  padding-left: 15px;
}

.MuiPagination-ul {
  justify-content: end;
  margin-top: 1.5rem !important;
}
.MuiPagination-ul .MuiButtonBase-root {
  font-weight: 600;
}

.MuiPaginationItem-root.Mui-selected {
  background-color: #D74E09 !important;
  opacity: 0.8 !important;
  color: #fff;
}

.tableHeading {
  font-size: 16px !important;
  font-weight: 600 !important;
  color: #464646 !important;
  margin-bottom: 1.8rem !important;
}

.tableHeading1 {
  font-size: 24px !important;
  font-weight: 600 !important;
  font-family: "Poppins" !important;
  color: #464646 !important;
  margin-top: 15px !important;
  margin-bottom: 1.8rem !important;
}

.roundCss {
  display: flex;
  text-align: center;
  vertical-align: middle;
  align-items: center;
  justify-content: center;
  background-color: #d9e1ef;
  max-width: 24px !important;
  height: 24px;
  border-radius: 50%;
}

.buttonCell {
  text-align: center !important;
  font-weight: 600 !important;
  font-size: 14px !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/style/sass/_media.scss","webpack://./src/assets/style/sass/all.scss","webpack://./src/assets/style/sass/_typography.scss","webpack://./src/assets/style/sass/custom.scss","webpack://./src/assets/style/sass/_variable.scss","webpack://./src/assets/style/sass/table.scss"],"names":[],"mappings":"AACA;EACE;IACE,2BAAA;ECCF;AACF;ACFA;EACE,2BAAA;EACA,0BAAA;EACA,4BAAA;EACA,cAAA;ADIF;;ACFA;EACE,kBAAA;EACA,2BAAA;EACA,0BAAA;EACA,4BAAA;EACA,cAAA;ADKF;;AEhBA;EACE,iCCIY;EDHZ,oCAAA;AFmBF;;AEjBA;EACE,UAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AFoBF;;AElBA;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AFqBF;;AEnBA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AFsBF;;AEpBA;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AFuBF;AEtBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AFwBJ;;AEpBE;EACE,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AFuBJ;;AEpBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AFuBF;AEtBE;EACE,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;AFwBJ;AEtBE;EACE,2BAAA;AFwBJ;AEtBE;EACE,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;AFwBJ;AEvBI;EACE,oBAAA;EACA,eAAA;AFyBN;;AEnBE;EACE,yBAAA;AFsBJ;AEpBE;EACE,yBAAA;AFsBJ;AEpBE;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;AFsBJ;AEpBE;EACE,wBAAA;AFsBJ;AEpBE;EACE,wBAAA;AFsBJ;AEpBE;EACE,4BAAA;AFsBJ;;AEhBA;EACE,aAAA;AFmBF;;AEhBA;EACE,kBAAA;EACA,oCAAA;EACA,2BAAA;EACA,gBAAA;EACA,iBAAA;AFmBF;;AEhBA;EACE,0BAAA;EACA,6BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;AFmBF;;AEjBA;EACE,eAAA;EACA,WAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AFoBF;;AElBA;EACE,oCAAA;EACA,sBAAA;EACA,8BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;AFqBF;;AEnBA;EACE,oCAAA;EACA,sBAAA;EACA,8BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;AFsBF;;AEpBA;EAEE,kBAAA;AFsBF;;AElBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AFqBJ;;AEvLA;EACE,iCCIY;EDHZ,oCAAA;AF0LF;;AExLA;EACE,UAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AF2LF;;AEzLA;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AF4LF;;AE1LA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AF6LF;;AE3LA;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AF8LF;AE7LE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AF+LJ;;AE3LE;EACE,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AF8LJ;;AE3LA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AF8LF;AE7LE;EACE,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;AF+LJ;AE7LE;EACE,2BAAA;AF+LJ;AE7LE;EACE,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;AF+LJ;AE9LI;EACE,oBAAA;EACA,eAAA;AFgMN;;AE1LE;EACE,yBAAA;AF6LJ;AE3LE;EACE,yBAAA;AF6LJ;AE3LE;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;AF6LJ;AE3LE;EACE,wBAAA;AF6LJ;AE3LE;EACE,wBAAA;AF6LJ;AE3LE;EACE,4BAAA;AF6LJ;;AEvLA;EACE,aAAA;AF0LF;;AEvLA;EACE,kBAAA;EACA,oCAAA;EACA,2BAAA;EACA,gBAAA;EACA,iBAAA;AF0LF;;AEvLA;EACE,0BAAA;EACA,6BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;AF0LF;;AExLA;EACE,eAAA;EACA,WAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AF2LF;;AEzLA;EACE,oCAAA;EACA,sBAAA;EACA,8BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;AF4LF;;AE1LA;EACE,oCAAA;EACA,sBAAA;EACA,8BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;AF6LF;;AE3LA;EAEE,kBAAA;AF6LF;;AEzLE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AF4LJ;;AI9VA;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,8BAAA;EACA,sBAAA;AJiWF;AIhWE;EACE,yBAAA;EACA,mBAAA;AJkWJ;AIhWE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,4BAAA;AJkWJ;AI/VE;EACE,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;AJiWJ;;AI9VA;EACE,oBAAA;EACA,6BAAA;AJiWF;AIhWE;EACE,gBAAA;AJkWJ;;AI/VA;EACE,oCAAA;EACA,uBAAA;EACA,WAAA;AJkWF;;AIhWA;EACE,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,gCAAA;AJmWF;;AIjWA;EACE,0BAAA;EACA,2BAAA;EACA,iCAAA;EACA,yBAAA;EACA,2BAAA;EAEA,gCAAA;AJmWF;;AIjWA;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,0BAAA;EACA,YAAA;EACA,kBAAA;AJoWF;;AIjWA;EACE,6BAAA;EACA,2BAAA;EACA,0BAAA;AJoWF","sourcesContent":["// media query for mobile view--------------------------////////\n@media (max-width: 900px) {\n  html {\n    font-size: 67.5% !important;\n  }\n}\n// media query for mobile view end--------------------///////////////////\n","// css-------------------------------- ////////////\n@import \"./media\";\n@import \"./typography\";\n@import \"./variable\";\n@import \"./custom.scss\";\n@import \"./table.scss\";\n@import url('https://fonts.googleapis.com/css2?family=Salsa&display=swap')\n\n// css ----------------------------////////////\n","@import \"./variable\";\n\n// css----------------------------- ////////////\n.MuiTypography-h4 {\n  font-weight: 600 !important;\n  font-size: 2rem !important;\n  line-height: 2rem !important;\n  color: #001e50;\n}\n.MuiTypography-h3 {\n  font-style: normal;\n  font-weight: 500 !important;\n  font-size: 1rem !important;\n  line-height: 24px !important;\n  color: #000000;\n}\n// css --------------------------////////////\n","@import \"./variable\";\r\n// css written here--------------------------------/////////\r\n\r\nbody {\r\n  font-family: $font-family;\r\n  background-color: #f8f8f8 !important;\r\n}\r\n.error {\r\n  color: red;\r\n  font-size: 12px;\r\n  padding-left: 5px;\r\n  margin-top: 2px;\r\n}\r\n.mainCardWrapper {\r\n  border: 1px solid #e0e4e9;\r\n  border-radius: 8px;\r\n  padding: 30px;\r\n  background-color: #fff;\r\n}\r\n.bxLabel {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  line-height: 24px;\r\n  color: #000;\r\n  margin-top: 15px;\r\n  margin-bottom: 15px;\r\n}\r\n.headerBx {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  border-radius: 8px;\r\n  background-color: #fff;\r\n  margin-bottom: 1rem;\r\n  padding: 10px 0px;\r\n  align-items: center;\r\n  p {\r\n    font-size: 24px;\r\n    font-weight: 500;\r\n    line-height: 36px;\r\n  }\r\n}\r\n.customBtn {\r\n  button {\r\n    border-radius: 8px;\r\n    height: 54px;\r\n    color: #fff !important;\r\n    font-family: Poppins;\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    line-height: 24px;\r\n  }\r\n}\r\n.searchBx {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 1rem;\r\n  .MuiInputBase-root {\r\n    height: 58px;\r\n    border-radius: 8px;\r\n    background-color: #fff;\r\n    width: 100%;\r\n  }\r\n  .MuiIconButton-edgeEnd {\r\n    padding-right: 0 !important;\r\n  }\r\n  .MuiButton-containedPrimary {\r\n    border-radius: 5px;\r\n    height: 40px !important;\r\n    font-size: 18px;\r\n    padding: 10px 10px;\r\n    font-weight: 600;\r\n    line-height: 24px;\r\n    text-transform: capitalize;\r\n    box-shadow: none;\r\n    background-color: #2a97ca;\r\n    color: #fff;\r\n    span {\r\n      font-family: Poppins;\r\n      font-size: 15px;\r\n    }\r\n  }\r\n}\r\n\r\n.customTab {\r\n  .MuiButtonBase-root {\r\n    border: 1px solid #e0e4e9;\r\n  }\r\n  .Mui-selected {\r\n    color: #2a97ca !important;\r\n  }\r\n  button {\r\n    height: 45px;\r\n    font-weight: 600;\r\n    font-size: 16px;\r\n    padding-left: 45px;\r\n    padding-right: 45px;\r\n    text-transform: capitalize;\r\n  }\r\n  button:first-child {\r\n    border-radius: 8px 0 0 0;\r\n  }\r\n  button:last-child {\r\n    border-radius: 0 8px 0 0;\r\n  }\r\n  .MuiTabs-flexContainer {\r\n    border-radius: 15px 15px 0 0;\r\n  }\r\n  // .MuiTabs-indicator {\r\n  //   height: 0px;\r\n  // }\r\n}\r\n.actionIcon {\r\n  display: flex;\r\n}\r\n\r\n.form-card {\r\n  border-radius: 8px;\r\n  border: 1px solid #e0e4e9 !important;\r\n  box-shadow: none !important;\r\n  background: #fff;\r\n  margin-bottom: 3%;\r\n}\r\n\r\n.cardHeading {\r\n  font-size: 16px !important;\r\n  font-style: normal !important;\r\n  font-weight: 500 !important;\r\n  line-height: normal !important;\r\n  margin-bottom: 12px !important;\r\n}\r\n.footer {\r\n  position: fixed;\r\n  bottom: 0px;\r\n  background: rgb(255, 255, 255);\r\n  text-align: center;\r\n  width: 100%;\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  z-index: 99999;\r\n}\r\n.activeBadge {\r\n  background-color: #c5eed8 !important;\r\n  color: #000 !important;\r\n  border-radius: 50px !important;\r\n  padding: 4px 28px !important;\r\n  font-size: 13px !important;\r\n  font-weight: 300 !important;\r\n}\r\n.inActiveBadge {\r\n  background-color: #eaeaea !important;\r\n  color: #000 !important;\r\n  border-radius: 50px !important;\r\n  padding: 4px 28px !important;\r\n  font-size: 13px !important;\r\n  font-weight: 300 !important;\r\n}\r\n.modalHeading {\r\n  // font-family: \"Salsa\" !important;\r\n  text-align: center;\r\n}\r\n.headPages {\r\n  // font-family: \"Salsa\" !important;\r\n  p {\r\n    font-size: 24px;\r\n    font-weight: 500;\r\n    line-height: 36px;\r\n  }\r\n}\r\n","// css ----------------------------////////////\n\n$primary: #2a97ca;\n$blackColor: #000000;\n$white: #ffffff;\n$rowHover: #edd6bf;\n$inputLabel: #343a40;\n$btnText: #464646;\n$font-family: \"Poppins\" !important;\n$card_border: \"#eaeaea\";\n// css --------------------------------------------////////////\n","@import \"./variable\";\n@import \"./custom.scss\";\n\n.tableWrapper {\n  padding: 24px;\n  border: 1px solid #e0e4e9;\n  padding: 30px 20px;\n  border-radius: 0px 0px 8px 8px;\n  background-color: #fff;\n  .MuiTableHead-root {\n    background-color: #f3f3f3;\n    white-space: noWrap;\n  }\n  .MuiTableCell-head {\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 21px;\n    letter-spacing: 0em;\n    color: #020202;\n    border-right: 1px solid #fff;\n  }\n\n  .MuiTableCell-body {\n    border-right: 1px solid #e7e7e7;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 18px;\n    color: #000000;\n    padding: 8px;\n    padding-left: 15px;\n  }\n}\n.MuiPagination-ul {\n  justify-content: end;\n  margin-top: 1.5rem !important;\n  .MuiButtonBase-root {\n    font-weight: 600;\n  }\n}\n.MuiPaginationItem-root.Mui-selected {\n  background-color: #D74E09 !important;\n  opacity: 0.8 !important;\n  color: #fff;\n}\n.tableHeading {\n  font-size: 16px !important;\n  font-weight: 600 !important;\n  color: #464646 !important;\n  margin-bottom: 1.8rem !important;\n}\n.tableHeading1 {\n  font-size: 24px !important;\n  font-weight: 600 !important;\n  font-family: \"Poppins\" !important;\n  color: #464646 !important;\n  margin-top: 15px !important;\n  // margin-left: 200px !important;\n  margin-bottom: 1.8rem !important;\n}\n.roundCss {\n  display: flex;\n  text-align: center;\n  vertical-align: middle;\n  align-items: center;\n  justify-content: center;\n  background-color: #d9e1ef;\n  max-width: 24px !important;\n  height: 24px;\n  border-radius: 50%;\n}\n\n.buttonCell {\n  text-align: center !important;\n  font-weight: 600 !important;\n  font-size: 14px !important;\n}\n\n// css--------------------////////////////////////\n\n// css--------------------////////////////////////\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
